import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import DetailTemplate from '../../common/template/DetailTemplate';
import EstimateListContainer from '../../../containers/projectmng/estimate/EstimateListContainer';
import EstimateModal from '../estimate/EstimateModal';
import { useDispatch } from 'react-redux';
import { projectOrderCount } from '../../../modules/projectModule/project';
import { listPartnerEmployees } from '../../../modules/partnerModule/employees';

const EstimateTemplate = () => {
  const dispatch = useDispatch();
  const { project, orderCount, vendorEmps } = useSelector(
    ({ projectModule, partnerModule }) => ({
      project: projectModule.project.project,
      orderCount: projectModule.project.orderCount,
      vendorEmps: partnerModule.partnerEmployees.employees,
    }),
  );

  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setData(null);
  };

  const editFunction = (params) => {
    //console.log(params, 'parent');
    setData(params);
    setOpen(true);
  };

  useEffect(() => {
    if (project) {
      dispatch(projectOrderCount(project.prjUuid));
      dispatch(listPartnerEmployees(project.vendorCmp));
    }
  }, [project]);

  return (
    <Box>
      {/* <DetailTemplate title="견적 세부사항">
        <EstimateDetailFormContainer />
      </DetailTemplate> */}

      <DetailTemplate title="견적 리스트">
        <EstimateListContainer editFunction={editFunction} />
      </DetailTemplate>
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {project && project?.costYn === 'Y' && (
          <Button
            variant="outlined"
            color="success"
            onClick={handleOpen}
            sx={{ mr: 1 }}
          >
            견적서 작성
          </Button>
        )}
      </Box> */}
      <EstimateModal
        project={project}
        type={data != null ? 'edit' : 'add'}
        estimate={data}
        open={open}
        orderCount={orderCount}
        vendorEmps={vendorEmps}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default EstimateTemplate;
